import { get, has, isArray, isString, isNumber, every } from 'lodash';
import { ValidationResult } from '../../models';

// dataObj: Using format 1 from https://api.highcharts.com/highcharts/series.bar.data
// xAxisCategoriesObj: Array of strings (https://api.highcharts.com/highcharts/xAxis.categories)
export const isValidCategoricalBarData = (dataObj: any, xAxisCategoriesObj?: any): ValidationResult => {
  let isDataObjValid = true;
  let isXAxisCategoriesObjValid = true;
  const errors: string[] = [];

  if (dataObj == undefined) {
    isDataObjValid = false;
    errors.push('Series is not defined');
    return { isValid: isDataObjValid, errors };
  }

  if (!isArray(dataObj)) {
    isDataObjValid = false;
    errors.push(`Series should be an array, but is of type ${typeof dataObj}`);
    return { isValid: isDataObjValid, errors };
  }

  isDataObjValid = every(dataObj, seriesObj => {
    let isSeriesValid = true;

    // Check that each series is an object with 'data' property
    if (!has(seriesObj, 'data')) {
      isSeriesValid = false;
      errors.push("Each series should be an object with a 'data' property");
    }

    // If 'data' exists, check if it is an array
    if (get(seriesObj, 'data') && !isArray(seriesObj.data)) {
      isSeriesValid = false;
      errors.push(`Data should be an array, but is of type ${typeof seriesObj.data}`);
    }

    if (get(seriesObj, 'data') && seriesObj.data.length > 0) {
      isSeriesValid = every(seriesObj.data, dataPoint => {
        let isPointValid = true;
        // Check that each point is a number
        if (!isNumber(dataPoint)) {
          isPointValid = false;
          errors.push(`Data point should be a number, but is of type ${typeof dataPoint}`);
        }
        return isPointValid;
      });
    }

    // Check if 'name' property, if it exists, is a string
    if (has(seriesObj, 'name') && !isString(seriesObj.name)) {
      isSeriesValid = false;
      errors.push(`Name should be a string, but is of type ${typeof seriesObj.name}`);
    }

    return isSeriesValid;
  });

  if (xAxisCategoriesObj != null) {
    if (!isArray(xAxisCategoriesObj)) {
      isXAxisCategoriesObjValid = false;
      errors.push(`X-axis categories should be an array, but is of type ${typeof xAxisCategoriesObj}`);
    } else {
      isXAxisCategoriesObjValid = every(xAxisCategoriesObj, category => {
        let isCategoryValid = true;
        if (!isString(category)) {
          isCategoryValid = false;
          errors.push(`X-axis category should be a string, but is of type ${typeof category}`);
        }
        return isCategoryValid;
      });
    }
  }

  if (errors.length > 0) {
    console.error('Error with categorical bar data: ', errors);
  }

  return { isValid: isDataObjValid && isXAxisCategoriesObjValid, errors };
};
